// extracted by mini-css-extract-plugin
export default {"intro":"progressive-module__intro--_3Q","logo-row":"progressive-module__logo-row--Sqn","logoRow":"progressive-module__logo-row--Sqn"};